import AdjustmentPropertyForm from "@/components/AdjustmentPropertyForm";
import AdjustmentSteps from "@/components/AdjustmentSteps";
import AuthenticatedLayout from "@/components/AuthenticatedLayout";
import BackToDashboard from "@/components/BackToDashboard";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useInertiaForm } from "@/hooks/useInertiaForm";
import { PageProps } from "@/types/PageProps";
import { Head } from "@inertiajs/react";
import { GrHelpBook } from "react-icons/gr";

type Props = PageProps & {};

type FormData = {
  address?: string;
  effective_date?: string;
};

export default function AdjustmentsNew({ user, errors, notice }: Props) {
  const form = useInertiaForm<FormData>({
    address: "",
    effective_date: "",
  });

  const submit = form.createSubmitHandler("/adjustments");

  return (
    <AuthenticatedLayout user={user} errors={errors} notice={notice}>
      <Head title="New Adjustment" />
      <div className="py-4">
        <BackToDashboard />

        <AdjustmentSteps currentStep="property" />
      </div>

      <div className="flex max-w-2xl mx-auto pt-4">
        <div className="w-full">
          <AdjustmentPropertyForm
            data={form.data}
            setData={form.setData}
            onSubmit={submit}
            processing={form.processing}
            errors={form.errors}
          />

          <Alert variant="muted" className="mt-4">
            <GrHelpBook className="w-5 h-5" />
            <AlertTitle className="text-lg">Need some help?</AlertTitle>
            <AlertDescription>
              <a
                href="https://teeba-calculator.com/instructions#subject-property-info"
                className="text-primary font-bold hover:underline"
                target="_blank"
              >
                Click here
              </a>{" "}
              to view more detailed instructions.
            </AlertDescription>
          </Alert>
        </div>
      </div>
    </AuthenticatedLayout>
  );
}
